module.exports = __webpack_public_path__ + "img/GF.29bdd218.svg";